(() => {
  if (window.TFFCReviewsStats) return;
  const store = 'www.amaranthineblooms.co.uk';
  const key = 'tffc-reviews-stats-v1';
  const valid = value => value && typeof value.rating === 'number' && Number.isFinite(value.rating) && value.rating >= (value.count ? 1 : 0) && value.rating <= 5 && Number.isSafeInteger(value.count) && value.count >= 0;
  const snapshotValid = value => value?.version === 1 && value.store === store && Number.isFinite(value.updatedAt) && value.updatedAt > 0 && value.updatedAt <= Date.now() && valid(value.product) && valid(value.company) && value.product.count + value.company.count > 0;
  const read = text => { try { return JSON.parse(text); } catch (_) { return null; } };
  let snapshot = window.TFFCReviewsSnapshot;
  if (!snapshotValid(snapshot)) snapshot = null;
  try {
    const saved = read(localStorage.getItem(key));
    if (snapshotValid(saved) && (!snapshot || saved.updatedAt > snapshot.updatedAt)) snapshot = saved;
  } catch (_) {}
  const manual = read(document.getElementById('reviews-fallback')?.textContent);
  let pending;
  let live = false;
  let attemptedAt = 0;
  const peek = (scope = 'combined') => {
    if (!snapshot) return valid(manual) && manual.count > 0 ? { ...manual, cached: true, scope: 'combined' } : null;
    const count = snapshot.product.count + snapshot.company.count;
    const value = scope === 'product' ? snapshot.product : { count, rating: (snapshot.product.rating * snapshot.product.count + snapshot.company.rating * snapshot.company.count) / count };
    return { ...value, cached: !live, scope, updatedAt: snapshot.updatedAt };
  };
  const renderTrustCount = (value, root) => {
    if (!value) return;
    const count = new Intl.NumberFormat(document.documentElement.lang || 'en').format(value.count);
    root.querySelectorAll('[data-reviews-total]').forEach(target => {
      if (target.isConnected) target.textContent = `${count} reviews`;
    });
    root.querySelectorAll('[data-reviews-count-template]').forEach(target => {
      if (target.isConnected) target.textContent = target.dataset.reviewsCountTemplate.replaceAll('[count]+', '[count]').replaceAll('[count]', count);
    });
    root.querySelectorAll('[data-reviews-average]').forEach(target => {
      if (target.isConnected) target.textContent = value.rating.toFixed(2);
    });
  };
  const get = (scope = 'combined') => {
    if (!live && pending && Date.now() - attemptedAt >= 60000) pending = null;
    if (!pending) {
      attemptedAt = Date.now();
      pending = fetch(`https://api.reviews.io/stats/all?store=${store}`, {
      credentials: 'omit', referrerPolicy: 'no-referrer', signal: AbortSignal.timeout(4000)
    }).then(response => response.ok ? response.json() : Promise.reject()).then(data => {
      const group = source => {
        if (!source || !['number', 'string'].includes(typeof source.average_rating) || !['number', 'string'].includes(typeof source.total_reviews) || String(source.average_rating).trim() === '' || String(source.total_reviews).trim() === '') return null;
        return { rating: Number(source.average_rating), count: Number(source.total_reviews) };
      };
      const next = { version: 1, store, updatedAt: Date.now(), product: group(data.product_review_stats), company: group(data.company_review_stats) };
      if (!snapshotValid(next)) throw new Error('Invalid review statistics');
      snapshot = next;
      live = true;
      try { localStorage.setItem(key, JSON.stringify(snapshot)); } catch (_) {}
      renderTrustCount(peek(), document);
    }).catch(() => {}).then(() => undefined);
    }
    return pending.then(() => peek(scope));
  };
  const updateTrustBar = (root = document) => {
    renderTrustCount(peek(), root);
    if (root.querySelector('[data-reviews-total], [data-reviews-count-template], [data-reviews-average]')) get().then(value => renderTrustCount(value, root));
  };
  window.TFFCReviewsStats = { get, peek, updateTrustBar };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => updateTrustBar(), { once: true });
  else updateTrustBar();
  document.addEventListener('shopify:section:load', event => updateTrustBar(event.target));
})();
